import { CUSTOM_PRICE } from 'components/OneColumnSearchResultPage/constants'

const getCorrectFilter = (filterArray = []) => {
  if (filterArray.length === 0) {
    return
  }

  return filterArray.filter(item => item.label !== CUSTOM_PRICE)
}

export const getCustomPriceFilter = (filterArray = []) =>
  filterArray.filter(item => item.label === CUSTOM_PRICE)

export default getCorrectFilter
